import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  return (
    <div className="min-h-screen bg-[#111111] flex items-center justify-center px-4">
      <Card className="max-w-md w-full bg-[#1a1a1a] border-red-500/30">
        <CardContent className="p-8 text-center">
          <XCircle className="w-20 h-20 text-red-500 mx-auto mb-6" />
          
          <h1 className="text-3xl font-bold text-white mb-4">
            Paiement Annulé
          </h1>
          
          <p className="text-[#A6A6A6] mb-6">
            Le paiement de votre commande <span className="text-white font-semibold">{orderId}</span> a été annulé.
          </p>
          
          <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4 mb-6">
            <p className="text-red-400 text-sm">
              Votre commande est toujours en attente de paiement.<br />
              Vous pouvez réessayer quand vous le souhaitez.
            </p>
          </div>
          
          <div className="space-y-3">
            <Button
              onClick={() => navigate('/client/new-order')}
              className="w-full bg-[#C00000] hover:bg-[#C00000]/90 text-white"
            >
              Créer une nouvelle commande
            </Button>
            
            <Button
              onClick={() => navigate('/client/dashboard')}
              variant="outline"
              className="w-full border-[#A6A6A6] text-white hover:bg-[#A6A6A6]/10"
            >
              Retour au tableau de bord
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
